import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Location, ProductService } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchProducts($where: ProductsWhereInput $limit: Int $offset: Int) {
    products(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-product-input',
  templateUrl: './fc-product-input.component.html',
  styleUrls: ['./fc-product-input.component.scss']
})
export class FcProductInputComponent {
  @Input()
  public control: FormControl;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public preloadOptions = false;

  @Input()
  public searchOnFocus = false;

  @Input()
  public label = null;

  @Input()
  public translateErrorPrefix: string;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<ProductService[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            nameContains: searchTerm,
            archived: false
          },
          limit,
          offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['products']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: ProductService): string {
    return value && value.name;
  }
}
